import script from "./statistics.vue?vue&type=script&lang=ts&setup=true"
export * from "./statistics.vue?vue&type=script&lang=ts&setup=true"

import "./statistics.vue?vue&type=style&index=0&id=6d561b85&lang=scss&scoped=true"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d561b85"]])

export default __exports__